var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showCounts)?_c('div',{staticClass:"filtered-notification"},[_c('div',{staticClass:"filtered-notification__used-filter"},[_vm._v(_vm._s(_setup.selectedFilterText))]),_c('div',{staticClass:"filtered-notification__filtered"},[_vm._v(_vm._s(_setup.text))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }